import React, { ReactNode, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { CollectionTableContentCard } from '../CollectionTable/CollectionTableContentCard';

export interface NestedTableContentContentBaseProps {
  children?: ReactNode;
}

export interface NestedTableContentContentProps
  extends NestedTableContentContentBaseProps {
  state: {
    showLoadingState: boolean;
    init: () => () => void;
  };
}

function _NestedTableContent(props: NestedTableContentContentProps) {
  const { state, children } = props;

  const { showLoadingState } = state;

  const showTableContent = !showLoadingState;

  useEffect(() => state.init(), []);

  return (
    <>
      {showTableContent && (
        <CollectionTableContentCard>{children}</CollectionTableContentCard>
      )}
    </>
  );
}

export const NestedTableContent = observer(_NestedTableContent);
